import CreateDeviceMigrationPage from '../../../components/assetManagement/CreateDeviceMigrationPage';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

export default {
	relativePath: 'create',
	component: CreateDeviceMigrationPage
} satisfies RouteConfig;
